import { Page } from "@/datastructures/Page";
import { PaginatedList } from "@/datastructures/PaginatedList";
import { FormRequestHandler } from "@/forms/FormRequestHandler";
import { FormResponse } from "@/forms/FormResponse";
import { SelectionItem } from "@/forms/ViewModelFormTypes";
import { OrderByClause, SortOrder } from "@/gateways/graphql/GraphQLConnection";
import { DateUtils } from "@/utils/DateUtils";
import { MaterialRequestGraphQLService } from "../services/MaterialRequestGraphQLService";

export class MaterialRequestOverviewController {
  public constructor(
    private presenter: IMaterialRequestOverviewPresenter,
    private MaterialRequestService: MaterialRequestGraphQLService
  ) {}

  public mounted() {
    this.getItems();
  }

  public parseDate(date: string) {
    return DateUtils.format(date);
  }

  public tableSorted(options: any) {
    this.presenter.options = options;

    if (!this.presenter.mounting) {
      this.getItems();
    }
  }

  public pageChanged(newPageNumber: number) {
    this.presenter.pageNumber = newPageNumber;

    if (!this.presenter.mounting) {
      this.getItems();
    }
  }

  public setMaterialRequestDone(id: string) {
    FormRequestHandler.handle(
      this.MaterialRequestService.setMaterialRequestDone(id),
      response => (this.presenter.setDoneRequest = response),
      "Konnte Materialanforderung nicht als erledigt markieren!"
    );
  }

  private getItems() {
    const order: OrderByClause[] = [];
    for (let i = 0; i < this.presenter.options.sortBy.length; i++) {
      order.push({
        field: this.presenter.options.sortBy[i],
        order: this.presenter.options.sortDesc[i]
          ? SortOrder.DESC
          : SortOrder.ASC
      });
    }

    const page = new Page(
      this.presenter.itemsPerPage,
      this.presenter.pageNumber
    );

    FormRequestHandler.handle(
      this.MaterialRequestService.getAllMaterialRequestsPaginated(
        page,
        order,
        this.presenter.search
      ),
      response => (this.presenter.tableRequest = response),
      "Konnte Tabelle nicht laden!"
    );
  }
}

export interface IMaterialRequestOverviewPresenter {
  mounting: boolean;
  tableRequest: FormResponse<PaginatedList<any>>;
  setDoneRequest: FormResponse<string>;

  pageNumber: number;
  itemsPerPage: number;
  options: any;
  search: string;
}
